import React from 'react';

const Bookmark = ({ size = 24, color = '#FA8072', fillColor = 'none' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fillColor}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.5 2H19.5V22L12 16.7143L4.5 22V2Z'
        stroke={color}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Bookmark;
